<template>
  <v-card flat hover :height="heightImage">
    <v-layout align-center justify-center row fill-height>
      <v-flex md12 text-md-center>
        <v-img 
          :src="section_image" 
          :height="heightImage"
          :style="$vuetify.breakpoint.smAndDown ? 'background-color: #F4F4F2' : ''"
        >
        </v-img>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    section_image:{
      type: String,
      required: true
    },
  },
  computed: {
    heightImage() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return "190px"
      } else {
        return "306px"
      }
    },
  }
}
</script>